module.exports = __webpack_public_path__ + "static/media/tenis.ac0b48c4.PNG";